import HeroCard from './HeroCard.jsx'
import support1 from '../img/support1.jpg'
import support2 from '../img/support2.jpg'
import ImageModal from './ImageModal.jsx'
import { useState } from "react";

const Support = () => {
    const [open, setOpen] = useState(false);
    return <div>
        <HeroCard image={support1} name={'SZJA 1%-ának fogadása'} title={'Név: Dunaújvárosi Judo Club Adószám: 18500495-1-03'} description={'A SZJA 1%-a egy egyszerű és hatékony mód arra, hogy támogassa Klubunk működését. Adóbevalláskor a fentebbi adatok szükségesek, hogy eljusson hozzánk adománya.'} isSquare={true} />
        <a
            href="#!"
            onClick={() => setOpen(true)}
            style={{ color: "#111", textDecoration: "none" }}
        >
            <HeroCard image={support2} name={'SZJA Felhasználás kimutatása'} description={'A 2023-as adóév 1% SZJA felhasználásának kimutatása'} isSquare={true} /></a>
        <ImageModal
            image={support2}
            isOpen={open}
            onClose={() => setOpen(false)}
        />
    </div>;
};

export default Support;